// Manual evidence areas that require human-uploaded documentation.
// These areas typically cannot be automatically verified via integrations.

export const MANUAL_EVIDENCE_AREAS = [
  {
    key: 'hr_people',
    name: 'HR & People',
    description: 'Employee onboarding, training records, background checks, code of conduct',
    controlPrefixes: ['CC1'],
    icon: 'Users',
  },
  {
    key: 'vendor_management',
    name: 'Vendor Management',
    description: 'Third-party risk assessments, vendor contracts, due diligence records',
    controlPrefixes: ['CC9'],
    icon: 'Building2',
  },
  {
    key: 'physical_security',
    name: 'Physical Security',
    description: 'Office access controls, visitor logs, environmental controls',
    controlPrefixes: ['CC6.4'],
    icon: 'Lock',
  },
  {
    key: 'business_continuity',
    name: 'Business Continuity',
    description: 'Disaster recovery plans, backup procedures, incident response testing',
    controlPrefixes: ['CC7.3', 'CC7.4', 'CC7.5'],
    icon: 'ShieldAlert',
  },
];
